/* eslint-disable no-unsafe-optional-chaining */
import React from 'react';
import isEmpty from 'lodash/isEmpty';

export function sortCategories(categoryOptions) {
	return [...categoryOptions]
		.filter((n) => !isEmpty(n.name))
		.sort((a, b) => {
			const nameA = a.name.toUpperCase();
			const nameB = b.name.toUpperCase();
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			return 0;
		});
}

export function sortPlants(plantOptions) {
	return [...plantOptions]
		.filter((n) => !isEmpty(n.name))
		.sort((a, b) => {
			const nameA = a.name.toUpperCase();
			const nameB = b.name.toUpperCase();
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			return 0;
		});
}

export function renderData(row) {
	const white = row.trimStart();
	const [plant, state] = white.split(', ');
	const [firstData, secondData] = plant.split('-');
	const [plants] = plant.split(',');
	const newPlant = plants
		.split(' ')
		.map((w) => w[0]?.toUpperCase() + w.substring(1)?.toLowerCase())
		.join(' ');

	if (state && firstData && secondData) {
		return (
			<>
				<span>
					{firstData}
					<span>-</span>
					{secondData}
				</span>
				<span className="caps">, {state}</span>
			</>
		);
	} else if (state && firstData) {
		return (
			<>
				<span>{firstData}</span>
				<span className="caps">, {state}</span>
			</>
		);
	}
	return newPlant;
}
